/**
 * Admin dashboard API endpoints.
 */

import { http } from './http';
import type { DashboardStats, DailyStats } from './types';

/** GET /api/v1/admin/dashboard/stats */
export async function getDashboardStats(): Promise<DashboardStats> {
  return http.get('/admin/dashboard/stats');
}

/** GET /api/v1/admin/dashboard/daily?days=7 */
export async function getDailyStats(days = 7): Promise<DailyStats[]> {
  return http.get<DailyStats[]>(`/admin/dashboard/daily?days=${days}`);
}
